import type { ReactNode } from 'react';

export const symbol_no_sim: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M424-880h316q24.75 0 42.38 18Q800-844 800-820v523q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-523H427l-83 83q-9 9-22 9t-22-8.61q-9-9.39-9-22.39t9-22l81-81q8-8 19.28-13 11.28-5 23.72-5ZM220-80q-24 0-42-18t-18-42v-470q0-12.44 4.5-23.72T178-653l19-18L60-808q-9-9-9-21t9-21.39Q69-859 81-859t21 9L867-85q9 9 9 21.16t-8.61 21Q858-34 845.9-34q-12.1 0-20.9-9L242-627l-22 22v465h520v-72l60 60v12q0 24-18 42t-42 18H220Zm315-422Zm-46 122Z"
		/>
	</svg>
);
